import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@ff-os/shared-react/components/buttons/icon-button/IconButton';
import { Cell } from '@ff-os/shared-react/components/grid/Cell';
import { Grid } from '@ff-os/shared-react/components/grid/Grid';
import { Icon } from '@ff-os/shared-react/components/icons/Icon';
import { Heading } from '@ff-os/shared-react/components/panel/Heading';
import { Panel } from '@ff-os/shared-react/components/panel/Panel';
import { useToggle } from '@ff-os/shared-react/hooks/useToggle';
import { TextInputControlProps } from '../TextInputControl';
import { FontFamilyDropdown } from './font-family/FontFamilyDropdown';
import { FontStylingOptions } from './styling-options/FontStylingOptions';
import { TextInputControlField } from './TextInputControlField';

export const TextInputControlPanel = ({
    name, hasFontStyling, variableIds, isWindowMode, isContentFirst
}: TextInputControlProps) => {

    const [showOptions, toggleOptions] = useToggle(isWindowMode && !isContentFirst);
    const { t } = useTranslation();

    return (
        <Panel>
            <Heading>{t(name)}</Heading>

            <Grid gap='s' wrap>
                <Cell full>
                    <Grid gap='s'>
                        <Cell>
                            <TextInputControlField variableIds={variableIds} />
                        </Cell>

                        <Cell fit>
                            {showOptions ? (
                                <IconButton active
                                    onClick={toggleOptions}
                                    title={t('text_input_control.collapse_options')}>
                                    <Icon type='font-family' />
                                </IconButton>
                            ) : (
                                <IconButton
                                    onClick={toggleOptions}
                                    title={t('text_input_control.expand_options')}>
                                    <Icon type='font-family' />
                                </IconButton>
                            )}
                        </Cell>
                    </Grid>
                </Cell>

                {showOptions && (
                    <>
                        <Cell fill>
                            <FontFamilyDropdown variableIds={variableIds} />
                        </Cell>

                        {hasFontStyling && (
                            <Cell fit>
                                <FontStylingOptions variableIds={variableIds} />
                            </Cell>
                        )}
                    </>
                )}
            </Grid>
        </Panel>
    );
};